import apiDuty from '@/api/duty'

const state = {
	data: {}
}

const getters = {
	data(state) {
		return state.data
	}
}

const mutations = {
	setData(state, data) {
		state.data = data
	}
}

const actions = {
	fetchData({ commit }) {
		apiDuty.getData(data => commit('setData', data))
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
